import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { AlertandloadingService } from "src/app/services/alertandloading.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-staking",
  templateUrl: "./staking.page.html",
  styleUrls: ["./staking.page.scss"],
})
export class StakingPage implements OnInit {
  transactionPassword: string;
  wallet_id: number;
  package_value: number;

  activeView: string = "send";
  transactionInfo: any;

  passInputConfig = {
    length: 4,
    inputClass: "otp-input-item",
    containerClass: "otp-input-holder",
    inputStyles: {
      width: "35px",
      height: "35px",
    },
    allowNumbersOnly: true,
  };

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private alertandLoading: AlertandloadingService,
    public api: ApiService
  ) {
    this.package_value = this.navParams.get("package_value");
    this.wallet_id = this.navParams.get("wallet_id");
  }

  ngOnInit() {}

  closeModal() {
    this.modalCtrl.dismiss(this.transactionInfo);
  }

  txnPasswordChanged(event: any) {
    this.transactionPassword = event;
  }

  async submit() {
    if (
      this.transactionPassword !== undefined &&
      this.transactionPassword.length == 4
    ) {
      let data = {
        wallet_id: this.wallet_id,
        package_value: this.package_value,
        txn_password: this.transactionPassword,
      };

      this.alertandLoading.presentLoading("processing request please wait");

      this.api.buyStakingPackage(data).then(
        (result: any) => {
          this.alertandLoading.dismissLoading();

          if (!result.error) {
            this.transactionInfo = result.data;
            this.activeView = "result";
          } else {
            this.alertandLoading.showAlert("Alert", result.message[0]);
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
          //console.log(error);
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Alert",
        "Please enter a valid 4 digit transaction password"
      );
    }
  }
}
